import { RuejaiClubBannerClient } from "./ruejaiClubBanners";
import { RuejaiClubCategoryClient } from "./ruejaiClubCategories";
import { RuejaiClubSalePackagesClient } from "./ruejaiClubSalePackages";
import { RuejaiClubVoucherPackageClient } from "./ruejaiClubVoucherPackage";
import { RuejaiClubGroupCategoryClient } from "./ruejaiClubGroupCategories";
import { RuejaiClubTierClient } from "./ruejaiClubTiers";
import { RuejaiClubPackagesClient } from "./ruejaiClubPackages";

export class RuejaiClubClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/ruejai_club`;

    this.banners = new RuejaiClubBannerClient(this.httpClient, this.baseURL);
    this.categories = new RuejaiClubCategoryClient(this.httpClient, this.baseURL);
    this.salePackages = new RuejaiClubSalePackagesClient(this.httpClient, this.baseURL);
    this.voucherPackages = new RuejaiClubVoucherPackageClient(this.httpClient, this.baseURL);
    this.groupCategories = new RuejaiClubGroupCategoryClient(this.httpClient, this.baseURL);
    this.tiers = new RuejaiClubTierClient(this.httpClient, this.baseURL);
    this.packages = new RuejaiClubPackagesClient(this.httpClient, this.baseURL);
  }
}
